import React from "react";

import { Error } from "@churchofjesuschrist/eden-alert";
import { Ghost, Secondary } from "@churchofjesuschrist/eden-buttons";
import { Row } from "@churchofjesuschrist/eden-row";
import { Stack } from "@churchofjesuschrist/eden-stack";
import { red20 as alertColor } from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";

import useCountdown from "../../generic/hooks/use-countdown/use-countdown";
import pad from "../../utils/pad";
import useManagedStrings from "../../utils/use-managed-strings";

const Header = styled.h3`
  margin: 0;
  padding: 0;
`;
//TODO: we don't have support in our eden library yet for the color on those gradients
//but I don't want to style it manually unless I absolutely have to.
//TODO: if we get theme support we would get rid of this style.
const Logout = styled(Ghost)`
  color: ${alertColor};
  &:hover {
    color: ${alertColor};
  }
`;

const stringGroups = [
  {
    name: "shared",
    keys: ["timeout", "timeoutMessage", "timeoutCounter", "continue", "logout"],
  },
];

const InactiveAlert = (props) => {
  const {
    onDismiss = () => {},
    onExpire = () => {},
    seconds: propSeconds = 60,
  } = props;

  const {remaining:seconds} = useCountdown({seconds:propSeconds, onComplete: onExpire});

  const minutes = pad(Math.floor(seconds / 60), 2);
  const useSeconds = pad(seconds % 60, 2);
  const { managedStrings: useStrings } = useManagedStrings(stringGroups);
  return (
    <Error data-id="inactive-alert">
      <Stack>
        <Header>{useStrings.timeout}</Header>
        <span>{useStrings.timeoutMessage}</span>
        <span>
          {useStrings.timeoutCounter}
          <br />
          <strong data-id="alert-countdown">
            {minutes}:{useSeconds}
          </strong>
        </span>
        <Row>
          <Secondary
            data-id="button-renew"
            theme={{ primaryColor: alertColor }}
            onClick={onDismiss}
          >
            {useStrings.continue}
          </Secondary>
          <Logout
            data-id="button-logout"
            onClick={onExpire}
            theme={{ primaryColor: alertColor }}
          >
            {useStrings.logout}
          </Logout>
        </Row>
      </Stack>
    </Error>
  );
};
export default InactiveAlert;
